module.exports = __webpack_public_path__ + "static/img/nose_01.42c8087.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/noses/thumbnail/nose_01.png
// module id = dzpK
// module chunks = 0